
import Vue from 'vue'
import { genesisIdToNetwork } from '../utils'

export default Vue.extend({
    data: () => {
        return {
            searchString: ''
        }
    },
    computed: {
        routeName(): string { return this.$route.name || '' },
        isHome(): boolean { return this.routeName === 'home' },
        price() { return this.$state.price },
        network() {
            switch (genesisIdToNetwork(this.$connex.thor.genesis.id)) {
                case 'main': return 'MainNet'
                case 'test': return 'TestNet'
                case 'solo': return 'Solo'
                case 'custom': return `Custom:0x${this.$connex.thor.genesis.id.slice(-2)}`
            }
        },
        switchableNetworks(): Array<{ name: string, href: string }> {
            switch (genesisIdToNetwork(this.$connex.thor.genesis.id)) {
                case 'main': return [{ name: 'TestNet', href: '#/test/' }]
                case 'test': return [{ name: 'MainNet', href: '#/main/' }]
                default: return [{ name: 'TestNet', href: '#/test/' }, { name: 'MainNet', href: '#/main/' }]
            }
        },
        networkBadgeVariant() {
            return genesisIdToNetwork(this.$connex.thor.genesis.id) === 'main' ? 'light' : 'warning'
        },
        alters() {
            return [
                { title: 'Official Explorer', href: 'https://explore.vechain.org/' },
                { title: 'VeChainStats', href: 'https://vechainstats.com/' },
                { title: 'VeBlocks', href: 'https://www.veblocks.net/' }
            ]
        },
        tools() {
            return [
                { title: 'Inspector', href: 'https://inspector.vecha.in' },
                { title: 'Tokens', href: 'https://laalaguer.github.io/vechain-token-transfer/' },
                { title: 'B32', href: 'https://b32.vecha.in' },
            ].filter(i => !!i.href)
        },
        routeViewKey() {
            if (this.$route.matched.find(i => i.name === 'account')) {
                return `accounts-${this.$route.params.address.toLowerCase()}`
            }
            return this.$route.fullPath
        }
    },
    methods: {
        search() {
            const str = this.searchString.trim()
            this.searchString = ''
            if (!str) {
                return
            }
            this.$router.push({ name: 'search', query: { q: str } })
        },
        routed() {
            const name = this.$route.name
            const params = this.$route.params

            let subTitle
            if (this.$route.matched.find(r => r.name === 'account')) {
                subTitle = 'Account ' + this.$options.filters!.checksum(params.address)
            } else if (name === 'tx') {
                subTitle = 'Tx ' + params.id
            } else if (name === 'block') {
                subTitle = 'Block ' + params.id
            } else if (name === 'search') {
                subTitle = 'Search'
            }
            document.title = subTitle ? `Insight | ${subTitle}` : 'Insight - VeChain Explorer'
        }
    },
    watch: {
        '$route.path'() {
            this.routed()
        }
    },
    created() {
        this.routed()
    }
})
